import * as React from 'react';
import { concat, differenceBy, find, flow, forEach, get, isEmpty, isEqual, map, union } from 'lodash';
import { change, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { Button, Col, Form, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { FormattedNumber } from 'react-intl';
import {
  IChannel,
  IOptionMap,
  IPaymentInfo,
  ISelectedTravellers,
  ITraveller
} from '../../../../../../../../data/api/models';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { FaSpinner } from 'react-icons/fa';
import Signposting, { SignpostType } from '../../../../../Components/Signposting';
import isSignPosted from '../../../../../../../../helpers/signpost';
import { Modal as BootstrapModal } from 'react-bootstrap/lib';
import { getPaymentUrl } from '../../../../../../../../data/api/api';
import {
  MTA_SET_PAYMENT_MODAL,
  MTA_UPDATE_FAILED,
  MTA_UPDATE_SUCCESS,
} from '../../../../../../../../services/mta/reducer';
import axios from 'axios';
import { push } from 'react-router-redux';
import Heap from '../../../../../../../../helpers/Heap';
import ConsentAndIntent from '../../../../../../../../components/ConsentAndIntent';
import { Prompt, withRouter } from 'react-router'
import DefinitionPopup from '../../../../../../../../components/DefinitionPopup';
import Loading from '../../../../../../../../components/Loading';
import TravellerDecline from '../../../../../Components/TravellerDecline';
import { ContactUs } from '../../../../../../../../components/ContactUs';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTAButtons } from '../../../MTAButtons';
import { MTASummaryOverview } from '../Components/MTASummaryOverview';
import { compareArrays } from '../../../../../../../../helpers/ArrayHelpers';
import { format, parse } from 'date-fns'

interface IMTASummaryFormProps extends InjectedFormProps<any> {
  options: IOptionMap;
  i18n: II18nMessages;
  mta: IMtaState;
  quote: any;
  channel: IChannel;
  payment: IPaymentInfo;
  formValues: any;
  visibility: { options: any };
  selectedScheme: any;
  signpost: any;
  dispatch: any;
  reuseCustomerAddress: boolean;
  paymentModal: { open: boolean, transactionId: string };
  permissions: boolean;
  paymentMethod: any;
  isUpsell: boolean;
  changingMedical: boolean;
  removeOption: string[];
  addingTravellers: boolean;
  selectedTravellers: ISelectedTravellers;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions;
    change: (form, field, value) => void;
    push(path: string);
  };
}

interface IMTASummaryFormState {
  nextLocation: any;
  rootClosePopover: boolean;
  signPosted: boolean;
  decline: boolean;
  contactUs: boolean;
  showCoolingOffPeriodMessage: boolean;
  loading: boolean;
  declineExistingTraveller: boolean;
  showExitPageModal: boolean;
}

const DATE_FORMAT = 'dd/MM/yyyy';

class MTASummaryForm extends React.Component<IMTASummaryFormProps, IMTASummaryFormState> {
  protected cvcOverlay: any = React.createRef();

  constructor(props) {
    super(props);
    const { change } = props;
    change('page', PageForm.MTA_SUMMARY);
    change('reuseCustomerAddress', true);
    change('permissions', true);
    window.scrollTo(0, 0);

    this.state = {
      nextLocation: null,
      rootClosePopover: true,
      signPosted: false,
      decline: false,
      contactUs: false,
      showCoolingOffPeriodMessage: false,
      loading: false,
      declineExistingTraveller: false,
      showExitPageModal: false,
    };

    this.initSummaryPage();
  }

  public initSummaryPage() {
    const { dispatch, change, actions, formValues } = this.props;
    if (process.env.BROWSER) {
      window.addEventListener('message', this.handleWindowMessage, { passive: true });
    }
    this.setState({ loading: true });
    Promise.all([
      actions.mta.resetAfterSubmit(),
      actions.mta.getCustomerPolicyPaymentMethod(),
      isSignPosted(actions.mta.getSelectedScheme(), dispatch, change, true, formValues),
    ]).then(() => {
      this.checkDeclineRules();
      this.setState({ loading: false });
    }).catch(() => {
      this.setState({ loading: false });
    });

  }

  public componentWillUnmount() {
    if (process.env.BROWSER) {
      window.removeEventListener('message', this.handleWindowMessage, { capture: false });
    }
  }

  private isOutsideOfCoolingOffPeriod = (selectedScheme): boolean => {
    const referrals = get(selectedScheme, 'referrals', []);
    const coolingOffReferral = find(referrals, ['name', 'region_downgrade']) ||
      find(referrals, ['name', 'reduce_cover_start_date']);
    return !!coolingOffReferral;
  }

  private checkDeclineRules = () => {
    const { actions, signpost } = this.props;
    const selectedPremium = this.getSelectedPremium();
    const selectedScheme = actions.mta.getSelectedScheme();
    if (!selectedPremium || signpost.isMedical) {
      if (this.isOutsideOfCoolingOffPeriod(selectedScheme)) {
        this.handleOutsideCoolingOff();
      } else {
        this.showTravellerDecline(selectedScheme)
        this.setState({ decline: true });
      }
      actions.mta.setCompleteMTA();
    }
  }

  private handleOutsideCoolingOff = () => {
    const { formValues } = this.props;
    const isAnnual = get(formValues, 'metadata.scheme_type', '') === 'annual';
    if (isAnnual) {
      this.setState({ showCoolingOffPeriodMessage: true });
      return;
    }

    if (!isAnnual) {
      this.setState({ contactUs: true });
      return;
    }
  }

  private showTravellerDecline(selectedScheme) {
    const { mta } = this.props;
    const originalTravellers = concat(mta.selectedPolicy.metadata.adults, mta.selectedPolicy.metadata.children);
    if (!this.addedTravellerMedicalQuestionDecline(selectedScheme, originalTravellers)) {
      this.addedTravellerMedicalDecline(selectedScheme, originalTravellers)
    }
  }

  private addedTravellerMedicalDecline = (selectedScheme, originalTravellers) => {
    const { formValues } = this.props;
    const travellers = get(formValues, 'travellers', []);
    const medicalReferral = get(selectedScheme, 'information.medical_max_score_referral', null);
    const newTravellers = differenceBy(travellers, originalTravellers, 'id')
    let newTravellerTrigger = false;
    let previousTravellerTrigger = false;

    if (medicalReferral) {
      forEach(medicalReferral, (medRef) => {
        if (find(newTravellers, ['id', get(medRef, 'id')])) {
          newTravellerTrigger = true;
        }

        if (find(originalTravellers, ['id', get(medRef, 'id')])) {
          previousTravellerTrigger = true;
        }
      })
    } else {
      const difference = travellers.filter((el) => !newTravellers.includes(el));

      forEach(difference, (origTr) => {
        if (get(origTr, 'screening.meta.hasAnnualExclusion') || get(origTr, 'screening.meta.hasWinterSportsExclusion')) {
          previousTravellerTrigger = true;
        }
      })

      forEach(newTravellers, (newTr) => {
        if (get(newTr, 'screening.meta.hasAnnualExclusion') || get(newTr, 'screening.meta.hasWinterSportsExclusion')) {
          newTravellerTrigger = true;
        }
      })
    }

    if (newTravellerTrigger && previousTravellerTrigger) {
      this.setState({ declineExistingTraveller: true })
      return;
    }

    if (!newTravellerTrigger && previousTravellerTrigger) {
      this.setState({ declineExistingTraveller: true })
      return;
    }

    if (newTravellerTrigger && !previousTravellerTrigger) {
      this.setState({ declineExistingTraveller: false })
      return;
    }

  }

  private addedTravellerMedicalQuestionDecline = (selectedScheme: any, originalTravellers: ITraveller[]): boolean => {
    const { selectedTravellers, addingTravellers } = this.props;
    const blockedMedicalQuestions = find(selectedScheme.referrals, ['name', 'blocked_medical_questions']);
    const allTravellersWithMedicalQuestions = union(get(selectedTravellers, 'waitingList', []), get(selectedTravellers, 'isTerminal', []))
    let newTraveller = false;
    let previousTraveller = false;
    if (!isEmpty(allTravellersWithMedicalQuestions) && !isEmpty(blockedMedicalQuestions)) {

      if (!addingTravellers) {
        this.setState({ declineExistingTraveller: true })
        return true;
      }

      allTravellersWithMedicalQuestions.forEach((id) => {
        if (!find(originalTravellers, ['id', id])) {
          newTraveller = true;
        } else {
          previousTraveller = true;
        }
      })

      if (previousTraveller) {
        this.setState({ declineExistingTraveller: true })
        return true;
      }

      if (!previousTraveller && newTraveller) {
        this.setState({ declineExistingTraveller: false })
        return true;
      }
    }

    return false;
  }

  private handleWindowMessage = (event: MessageEvent) => {
    const { dispatch, formValues, actions } = this.props;

    // For Chrome, the origin property is in the event.originalEvent object.
    const origin = event.origin || get(event, 'originalEvent.origin');

    if (origin !== axios.defaults.baseURL) {
      return;
    }

    const data = event.data;

    if (data.status !== 'complete') {
      // Show an error?

      dispatch({ type: MTA_UPDATE_FAILED, payload: 'Payment Error' });
      this.closeModal();
      return;
    }

    this.closeModal();

    const premium = this.getSelectedPremium();
    const selectedScheme = actions.mta.getSelectedScheme();
    const coverLevel = get(selectedScheme, 'scheme.cover_level', '');
    premium.information = selectedScheme?.information || null
    dispatch({
      type: MTA_UPDATE_SUCCESS,
      payload: {
        changes: null,
        policyId: get(formValues, 'id', null),
        grossPremium: premium?.gross || null
      },
    });
    Heap.trackEvent('PurchaseSuccess', formValues, 'policy', { premium, coverLevel })
    dispatch(push(`/account/make-a-change/complete`));
  }

  private routerWillLeave = (nextLocation) => {
    const { signPosted, decline, showCoolingOffPeriodMessage } = this.state
    if (this.state.nextLocation) {
      return this.state.nextLocation
    } else if (nextLocation.pathname === '/login' || nextLocation.pathname === '/account/make-a-change/complete' || nextLocation.pathname === '/complete') {
      return true
    } else if (signPosted || decline || showCoolingOffPeriodMessage) {
      return true;
    }
    this.showExitPageModal(nextLocation);
    return false
  }

  private optionRemovalOutsideCoolingOff = (): boolean => {
    const { removeOption } = this.props;
    const selectedPremium = this.getSelectedPremium();
    return removeOption.length > 0 && selectedPremium.gross === 0 && !isEmpty(selectedPremium.options)
  }

  private renderAdditionalOptions = () => {
    const { actions, visibility } = this.props;
    const product = actions.branding.getProduct();
    const selectedPremium = this.getSelectedPremium();

    if (!visibility || !selectedPremium) {
      return;
    }

    const addedOptions = map(visibility.options, (value: any, key) => {
      const productOption = product.metadata.options[key];

      if (productOption && (productOption.type === 'boolean' || productOption.type === 'question') && value === true) {
        return (
          <div className={'mta-o-attribute'} key={key}>
            <div>{productOption.name}</div>
          </div>
        );
      }

    }).filter((option) => !!option);

    if (addedOptions.length === 0) {
      return null;
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>Add additional cover</div>
          <div className={'mta-o-attribute-value'}> {addedOptions}</div>
        </div>
      </div>
    );
  }

  private renderOptionRemoval = () => {
    const { removeOption } = this.props;
    const selectedPremium = this.getSelectedPremium();

    if (this.optionRemovalOutsideCoolingOff()) {
      const optionNames = Object.keys(selectedPremium.options).join(', ');
      return (
        <div style={{ padding: '15px' }}>
          <div>
            Unfortunately, we do not offer a refund for cancelling {optionNames} after the cooling-off period.
          </div>
          <div style={{ marginTop: '15px' }}>
            Please contact our customer service team on <b>0333 234 9913</b> if you require further information
            regarding this.
          </div>
          <div style={{ marginTop: '15px' }}>
            Please confirm whether you would still like to cancel by selecting an option below.
          </div>
        </div>
      )
    }

    if (removeOption.length > 0 && selectedPremium.gross < 0 && !isEmpty(selectedPremium.options)) {
      return (
        <div className={'mta-overview-row'}>
          <div className={'mta-o-attribute'}>
            <div>{'Remove additional cover'}</div>
            <div className={'mta-o-attribute-value'}>
              {map(selectedPremium.options, (option, key) => {
                return (
                  <div>{key}</div>
                )
              })}
            </div>
          </div>
        </div>
      );
    }

    return null;

  }

  private renderQuoteReference = () => {
    const { quote } = this.props;

    if (this.optionRemovalOutsideCoolingOff()) {
      return;
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>Reference number</div>
          <div className={'mta-o-attribute-value'}>{quote.data.attributes.quote_reference || null}</div>
        </div>
      </div>
    );
  }

  private renderEffectiveDate = () => {
    const { mta: { mtaQuote } } = this.props
    const effectiveDate = format(new Date(mtaQuote?.data?.attributes?.effective_date), DATE_FORMAT)

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>Effective from</div>
          <div className={'mta-o-attribute-value'}>{effectiveDate}</div>
        </div>
      </div>
    );
  }

  private renderTripTypeChange = () => {
    const { mta, formValues } = this.props;
    const isPolicySingle = get(mta, 'selectedPolicy.metadata.scheme_type', '') === 'single';
    const isUpsell = get(formValues, 'metadata.scheme_type', '') === 'annual';

    if (!isPolicySingle || !isUpsell) {
      return;
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>Type of policy changed to</div>
          <div className={'mta-o-attribute-value'}>{'Annual Multi Trip Cover'}</div>
        </div>
      </div>
    );
  }

  private isAmtUpsell = (): boolean => {
    const { isUpsell } = this.props;
    return isUpsell
  }

  private renderDestinationChange = () => {
    const { formValues, mta, actions } = this.props;
    let title = ' Region Change to';
    let content = '';
    const isAnnual = get(formValues, 'metadata.scheme_type', '') === 'annual'
    const productRegions = get(actions.branding.getProduct(), 'metadata.regions');

    if (isAnnual) {
      if (get(formValues, 'metadata.region') === get(mta, 'selectedPolicy.metadata.region')) {
        return;
      } else {
        content = get(productRegions, get(formValues, 'metadata.region'));
      }
    } else {
      if (isEqual(get(formValues, 'metadata.destinations'), get(mta, 'selectedPolicy.metadata.destinations'))) {
        return;
      } else {
        title = 'Destination Change to';
        content = get(formValues, 'metadata.destinations', []).toString()
      }
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>{title}</div>
          <div className={'mta-o-attribute-value'}>{content}</div>
        </div>
      </div>
    );
  }

  private renderMaxTripDurationChange = () => {
    const { formValues, mta } = this.props;
    const isAnnual = get(formValues, 'metadata.scheme_type', '') === 'annual'
    const hasChanged = get(formValues, 'metadata.max_trip_duration') !== get(mta, 'selectedPolicy.metadata.max_trip_duration')

    if (!isAnnual || !hasChanged) {
      return null;
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>{'Maximum Trip length change to'}</div>
          <div className={'mta-o-attribute-value'}>Up to {get(formValues, 'metadata.max_trip_duration')} days</div>
        </div>
      </div>
    );

  }

  private renderDateChange = () => {
    const { formValues, mta } = this.props;

    const isAnnual = get(formValues, 'metadata.scheme_type', '') === 'annual'
    const title = ' Change trip dates to';
    let contentStartDate = '';
    let contentEndDate = '';
    const isStartDateChanged = !isEqual(get(formValues, 'metadata.start_date'), get(mta, 'selectedPolicy.metadata.start_date'));
    const isEndDateChanged = !isEqual(get(formValues, 'metadata.end_date'), get(mta, 'selectedPolicy.metadata.end_date'));
    const canShowUpsellInfo = this.isAmtUpsell();

    if (isAnnual) {
      if (!isStartDateChanged) {
        return;
      } else {
        contentStartDate = isStartDateChanged ? get(formValues, 'metadata.start_date') : '';
        contentEndDate = isStartDateChanged ? get(formValues, 'metadata.end_date') : '';
      }
    } else {
      if (!isStartDateChanged && !isEndDateChanged) {
        return;
      } else {
        contentStartDate = isStartDateChanged || isEndDateChanged ? get(formValues, 'metadata.start_date') : '';
        contentEndDate = isStartDateChanged || isEndDateChanged ? get(formValues, 'metadata.end_date') : '';
      }
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>
            {title}
            {canShowUpsellInfo && (
              <DefinitionPopup
                name="benefit-info"
                definition={'The date your policy starts will be the same date as when you chose your original Single Trip policy to start.'}
                iconType="info"
              />
            )}
          </div>
          <div className={'mta-o-attribute-value'}>
            {contentStartDate && (
              <div>
                {'Start Date: ' + format(new Date(contentStartDate), 'dd/MM/yyyy')}
              </div>
            )}
            {contentEndDate && (
              <div>
                {'End Date: ' + format(new Date(contentEndDate), 'dd/MM/yyyy')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private renderSchemeChange = () => {
    const { mta, actions } = this.props;
    const policySchemeId = get(mta, 'selectedPolicy.metadata.scheme_id');
    const previousSchemeCoverLevel = get(find(mta.selectedPolicy.premiums, ['scheme.id', policySchemeId]), 'scheme.coverLevel');
    const selectedSchemeCoverLevel = get(actions.mta.getSelectedScheme(), 'scheme.cover_level');

    if (!previousSchemeCoverLevel || !selectedSchemeCoverLevel || previousSchemeCoverLevel === selectedSchemeCoverLevel) {
      return;
    }

    return (
      <div className={'mta-overview-row'}>
        <div className={'mta-o-attribute'}>
          <div>{'Level of Cover change to'}</div>
          <div className={'mta-o-attribute-value'}>{selectedSchemeCoverLevel.toUpperCase()}</div>
        </div>
      </div>
    );
  }

  private displayTravellerDetails = (traveller: ITraveller) => {
    const conditions = get(traveller, 'screening.meta.conditions', []);
    const parsedDate = parse(traveller.dob, 'dd/MM/yyyy', new Date());
    const dob = format(parsedDate, 'dd/MM/yyyy');
    const firstName = get(traveller, 'firstName', get(traveller, 'first_name'))
    const lastName = get(traveller, 'lastName', get(traveller, 'last_name'))
    return (
      <div style={{ marginBottom: '15px' }}>
        <div>Name: {traveller.title} {firstName} {lastName}</div>
        <div>Date of birth: {dob}</div>
        <div>Medical Conditions: <span>{isEmpty(conditions) ? 'None' : conditions.toString()}</span>
        </div>
      </div>
    )
  }

  private renderAdditionalTraveller = () => {
    const { formValues, mta } = this.props;
    const originalTravellers = concat(mta.selectedPolicy.metadata.adults, mta.selectedPolicy.metadata.children);
    let title = ' Add Traveller(s)';
    let travellerDifference = [];
    let removal = false;

    if (formValues.travellers.length === originalTravellers.length) {
      return;
    }

    if (formValues.travellers.length < originalTravellers.length) {
      title = 'Removed Traveller(s)'
      travellerDifference = originalTravellers.filter((objFromA) => {
        return !formValues.travellers.find((objFromB) => {
          return objFromA.title === objFromB.title && objFromA.first_name === objFromB.firstName && objFromA.last_name === objFromB.lastName
        })
      })
      removal = true;
    }

    return (
      <>
        <div className={'mta-overview-row'}>
          <div className={'mta-o-attribute'}>
            <div>{title}</div>
            <div className={'mta-o-attribute-value'}>
              {!removal && (
                <>
                  {map(formValues.travellers, (traveller, key) => {
                    if (!originalTravellers[key]) {
                      return (
                        <div key={key}>
                          {this.displayTravellerDetails(traveller)}
                        </div>
                      );
                    }
                  })}
                </>
              )}

              {removal && travellerDifference.length > 0 && (
                <>
                  {map(travellerDifference, (traveller, key) => {
                    if (originalTravellers[key]) {
                      return (
                        <div key={key}>
                          {this.displayTravellerDetails(traveller)}
                        </div>
                      );
                    }
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  private renderMedical = () => {
    const { formValues, mta } = this.props;
    const originalTravellers = concat(mta.selectedPolicy.metadata.adults, mta.selectedPolicy.metadata.children);
    return (
      <>
        <div className={'mta-overview-row'}>
          <div className={'mta-o-attribute'}>
            <div>{'An update to medical Conditions'}</div>
            <div className={'mta-o-attribute-value'}>
              <div>
                {map(formValues.travellers, (traveller, key) => {
                  const conditions = get(traveller, 'screening.meta.conditions', []);
                  const originalConditions = get(originalTravellers[key], 'screening.meta.conditions', [])
                  const changed = compareArrays(originalConditions, conditions)
                  const shouldShow = changed?.addedValues?.length > 0 || changed?.changedValues?.length > 0 || changed?.removedValues?.length > 0;

                  return (
                    <div key={key}>

                      {shouldShow && (
                        <div>
                          {this.displayTravellerDetails(traveller)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  private getSelectedPremium = () => {
    const { actions } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme();
    return selectedScheme.premium || null;
  }

  private renderPremium = () => {
    const { mta, change, removeOption } = this.props;
    const quotes = mta.quotes;
    const selectedPremium = this.getSelectedPremium();
    const isReturnPremium = get(selectedPremium, 'gross', 0) < 0;
    const isZeroPremium = get(selectedPremium, 'gross', 0) === 0;
    const showRemoveOptionText = removeOption.length > 0 && selectedPremium.gross < 0 && !isEmpty(selectedPremium.options);
    const hidePremium = removeOption.length > 0 && selectedPremium.gross === 0;
    change('premium', get(selectedPremium, 'gross', 0))

    if (!quotes || !selectedPremium || hidePremium) {
      return null;
    }
    return (
      <>
        <div className={'mta-overview-row'}>
          <div className={'mta-o-attribute'}>
            <div>
              {isZeroPremium && (
                <p className={'mta-summary-price-text'}>{isReturnPremium ? 'Amount to be refunded' : 'Price to pay'}</p>
              )}
              {!isZeroPremium && (
                <p className={'mta-summary-price-text'}>{isReturnPremium ? 'Refund of' : 'Price to pay'}</p>
              )}
              {!isReturnPremium && (
                <div>
                  <div className="info-note">
                    {isZeroPremium && (
                      <div>We do not offer a refund for cancelling an additional cover after the cooling-off
                        period.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={'mta-o-attribute-value mta-summary-price-value'}>
              <FormattedNumber
                value={selectedPremium.gross}
                style="currency"
                currency={selectedPremium.currency}
              />
            </div>
          </div>
          {showRemoveOptionText && (
            <div style={{ marginTop: '15px' }}>Please confirm whether you would still like to cancel by selecting an
              option below.</div>
          )}
        </div>
      </>
    );
  }

  private renderMTASummaryDetails = () => {
    const { mta: { mtaQuote }, actions } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme()
    return (
      <div>
        <div className={'mta-overview-row blue_text'}><b>Here's a summary of your policy if you continue to pay and
          confirm this change.</b>
        </div>
        <MTASummaryOverview
          policyApplication={mtaQuote?.data?.attributes}
          selectedScheme={selectedScheme}
        />
      </div>
    )
  }

  public handleSubmit = () => {
    const { actions } = this.props;
    actions.mta.handleMTASubmit();
  }

  public closeModal = () => {
    const { dispatch } = this.props;
    dispatch({ type: MTA_SET_PAYMENT_MODAL, payload: { open: false, transactionId: '' } });
  }

  private renderPaymentModal = () => {
    const { paymentModal } = this.props;
    return (
      <BootstrapModal
        show={true}
        onHide={this.closeModal}
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader closeButton={false}>
          <ModalTitle>Payment</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <iframe src={getPaymentUrl(paymentModal.transactionId)} className="payments-modal"/>
        </ModalBody>
      </BootstrapModal>
    );
  }

  private showExitPageModal = (nextLocation) => {
    this.setState({ showExitPageModal: true, nextLocation })
  }

  private closeExitPageModal = () => {
    this.setState({ showExitPageModal: false, nextLocation: null })
  }

  private handleExitPageSubmit = () => {
    const { dispatch, actions } = this.props;
    const { nextLocation } = this.state;

    const allowedRoutes = ['/account/renewals', '/account/quotes', '/account/policies', '/account/summary', '/account/claims', '/auth/login', '/account/manage']

    this.setState({ nextLocation }, () => {
      actions.mta.setCompleteMTA();
      this.closeModal();
      if (allowedRoutes.includes(nextLocation.pathname)) {
        dispatch(push(nextLocation))
      } else {
        dispatch(push('/account/make-a-change'))
      }
    })
  }

  private renderExitPageModal = () => {
    const { showExitPageModal } = this.state;
    return (
      <BootstrapModal
        show={showExitPageModal}
        onHide={this.closeExitPageModal}
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader closeButton={false}>
          <ModalTitle>Are you sure you wish to leave this page?</ModalTitle>
        </ModalHeader>
        <ModalBody>
          You have not yet completed your requested change. If you leave this page your changes will not be saved, and
          your policy will not be updated. It is important that your details are kept up to date, as incorrect
          information could invalidate your cover or affect any future claims.
        </ModalBody>
        <ModalFooter>
          <Button bsStyle="primary"
                  className="secondary-button"
                  onClick={this.handleExitPageSubmit}
          >
            {'PROCEED WITHOUT SAVING'}
          </Button>
          <Button bsStyle="primary"
                  className="secondary-button"
                  onClick={this.closeExitPageModal}
          >
            {'CANCEL'}
          </Button>
        </ModalFooter>
      </BootstrapModal>
    )
  }

  private handleBackButton = () => {
    const { actions } = this.props;
    actions.push(`/account/summary`)
  }

  private scrollToBottom = () => {
    window.scrollTo(0, document.body.scrollHeight);
  }

  private contactUs = () => {
    window.open('https://www.admiral.com/contact-us/travel', '_blank')
  }

  private renderGatewayErrorMessage = () => {
    const { quote } = this.props;
    const quoteReference = get(quote, 'data.attributes.quote_reference', null);
    return (
      <Row>
        <Col>
          <p><b>We were unable to process your payment request.</b></p>
          <p>No payment has been taken and no insurance cover is in place.</p>
          <p style={{ margin: '20px 0 20px 0' }}>
            <b>
              <span onClick={this.scrollToBottom} className={'link-element'}>Click here to try again</span>
            </b>
          </p>
          <p>If you experience any further problems, please <span
            onClick={this.contactUs} className={'link-element'}>contact us</span> so we can help you further.
          </p>
          <p>Your quote details have been saved – quote Ref {quoteReference}</p>
        </Col>
      </Row>
    )
  }

  private renderDeclinePaymentErrorMessage = () => {
    const { quote } = this.props;
    const quoteReference = get(quote, 'data.attributes.quote_reference', null);
    return (
      <Row>
        <Col>
          <p><b>Your payment has been declined by your bank.</b></p>
          <p className={'margin-bottom'}>No payment has been taken and no insurance cover is in place.</p>
          <p><b><span onClick={this.scrollToBottom}
                      className={'link-element'}>Click here</span> to
            try again or change your card details.</b></p>
          <p>Your details have been saved – quote Ref {quoteReference}</p>
        </Col>
      </Row>
    )
  }

  public render() {
    const {
      i18n,
      change,
      channel,
      dispatch,
      reuseCustomerAddress,
      permissions,
      quote,
      handleSubmit,
      submitting,
      submitFailed,
      valid,
      mta,
      signpost,
      formValues,
      paymentModal,
      paymentMethod,
      actions,
      addingTravellers,
      changingMedical = false,
      isUpsell
    } = this.props;
    const { loading, declineExistingTraveller, decline, showCoolingOffPeriodMessage, contactUs } = this.state;
    const leadTraveller = get(formValues, 'travellers[0]', null);
    const quoteReference = get(quote, 'data.attributes.quote_reference', null);
    const isReturnPremium = get(this.getSelectedPremium(), 'gross', 0) < 0;
    const zeroPremium = get(this.getSelectedPremium(), 'gross', 0) === 0;
    const hideConsentAndIntent = isReturnPremium || zeroPremium
    const showMedical = !addingTravellers && changingMedical;
    const isOptionRemovalOutsideCoolingOff = this.optionRemovalOutsideCoolingOff();
    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        className="pull-right secondary-button"
        disabled={
          submitting ||
          (submitFailed && !valid) ||
          mta.isLoading
        }
      >
        {mta.isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        {isReturnPremium ? 'ISSUE REFUND' : zeroPremium ? 'CONFIRM CHANGES' : 'PAY AND CONFIRM CHANGES'}
      </Button>
    );

    const backButton = (
      <Button
        id="back"
        bsStyle="primary"
        type="button"
        className="secondary-button pull-left medium-width"
        onClick={this.handleBackButton}
        disabled={
          submitting ||
          (submitFailed && !valid) ||
          mta.isLoading
        }
      >GO BACK</Button>
    )

    if (loading) {
      return (
        <Loading/>
      )
    }

    return (
      <>
        <Prompt when={true} message={this.routerWillLeave}/>
        {quote && !decline && !showCoolingOffPeriodMessage && !contactUs && (
          <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
            {mta.afterSubmit.error && (
              <div className="error-block-container">
                <h1>Whoops!</h1>
                {mta.afterSubmit.error && mta.afterSubmit.error !== 'Payment Error' && (
                  <>
                    {this.renderGatewayErrorMessage()}
                  </>
                )}
                {mta.afterSubmit.error && quoteReference && mta.afterSubmit.error === 'Payment Error' && (
                  <>
                    {this.renderDeclinePaymentErrorMessage()}
                  </>
                )}
              </div>
            )}
            {signpost.isSignposted && (
              <div style={{ margin: '20px 0' }}>
                <Signposting type={SignpostType.TYPE_A} medical={false}/>
              </div>
            )}
            <div className={'mt-30'}/>
            <div className="admiral-card">
              <MTACardHeader
                text={'Please check and confirm the below changes to be applied to your policy.'}
                icon={isOptionRemovalOutsideCoolingOff ? 'warning' : 'edit'}
                subtext={'Prices include IPT of 20% where applicable.'}
              />
              <div className="mta-details-overview">
                <div>
                  <div>
                    {this.renderQuoteReference()}
                    {this.renderTripTypeChange()}
                    {!isUpsell && this.renderDestinationChange()}
                    {!isUpsell && this.renderMaxTripDurationChange()}
                    {!isUpsell && this.renderDateChange()}
                    {this.renderSchemeChange()}
                    {this.renderAdditionalTraveller()}
                    {showMedical && this.renderMedical()}
                    {this.renderAdditionalOptions()}
                    {this.renderOptionRemoval()}
                    {this.renderEffectiveDate()}
                    {this.renderPremium()}
                    {this.renderMTASummaryDetails()}
                  </div>
                  {!hideConsentAndIntent && (
                    <ConsentAndIntent
                      permissions={permissions}
                      leadTraveller={leadTraveller}
                      i18n={i18n}
                      change={change}
                      channel={channel}
                      hidePermissions={this.isAmtUpsell()}
                      dispatch={dispatch}
                      reuseCustomerAddress={reuseCustomerAddress}
                      isMta={true}
                      paymentMethod={paymentMethod}
                      actions={actions}
                      mtaIsLoading={mta.isLoading}/>
                  )}
                  {paymentModal?.open && this.renderPaymentModal()}
                </div>
              </div>
            </div>

            <div className={'mt-30'}/>
            <MTAButtons
              button1={backButton}
              button2={submitButton}
            />
          </Form>
        )}
        {showCoolingOffPeriodMessage && (
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <div className="call-center">
              <div>
                <h3 className="title">WHOOPS!</h3>
                <p>
                  Unfortunately we are unable to make the change requested as you are outside of your cooling off
                  period.
                </p>
              </div>
            </div>
          </div>
        )}
        {decline && (
          <div style={{ textAlign: 'center' }}>
            <>
              <TravellerDecline isExisting={declineExistingTraveller}/>
            </>
          </div>
        )}
        {contactUs && (
          <div style={{ textAlign: 'center' }}>
            <>
              <ContactUs/>
            </>
          </div>
        )}

        {this.renderExitPageModal()}
      </>
    );
  }
}

let selector;

export default flow([
  withRouter,
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const options = selector(state, 'data.attributes.metadata.options');
      const channel = state.branding.channel;
      const visibility = selector(state, 'visibility');
      const payment = selector(state, 'payment');
      const reuseCustomerAddress = selector(state, 'reuseCustomerAddress');
      const permissions = selector(state, 'permissions');
      const values = selector(state, 'data.attributes');
      const isUpsell = selector(state, 'isUpsell');
      const changingMedical = selector(state, 'changingMedical');
      const removeOption = selector(state, 'removeOption');
      const addingTravellers = selector(state, 'addingTravellers');
      const selectedTravellers = selector(state, 'selectedTravellers');
      return {
        mta: state.mta,
        paymentMethod: state.mta.paymentMethod,
        signpost: state.mta.signpost,
        quote: state.mta.mtaQuote,
        i18n: state.branding.i18n,
        channel,
        options,
        visibility,
        formValues: values,
        payment,
        permissions,
        reuseCustomerAddress,
        paymentModal: state.mta.paymentModal,
        isUpsell,
        changingMedical,
        addingTravellers,
        selectedTravellers,
        removeOption,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        change: bindActionCreators(change, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(MTASummaryForm);
